import { emailTemplate } from './emailTemplate';
import { IS_SIDEKICK_APP } from '../constants/projects';

const newReviewTemplate = (firstName, link) => {
    return emailTemplate(
        `
                            <h1 class="body-text">Hi ${firstName}</h1>
                            <b class="body-text">Hoorah! Your post is getting comments.</b> 
                            <p class="body-text" style="margin-top: 30px; margin-bottom: 30px;">Login to see what they’re saying in response to your question.</p>
                            <p class="body-text" style="margin-bottom: 30px">Fingers crossed you’ll find some pearls of wisdom!</p>
                            <b class="body-text">Validate team</b>
                            `,
        'Go to post',
        link,
        {
            headerColor: '#FFF8E0',
            logoColor: '#FFCF31',
            bodyBg:
                'https://firebasestorage.googleapis.com/v0/b/validate-web-platform.appspot.com/o/static%2Fcomment_email_bg.png?alt=media&token=69f034b9-a957-4ba2-8fed-6f2ce2db12ee',
        },
        IS_SIDEKICK_APP
    );
};

export const getNewReviewTemplate = (email, firstName, postId) => {
    const link = `${window.location.origin}/posts/${postId}`;
    return {
        subject: `You’re getting advice.`,
        sendTo: [email],
        body: newReviewTemplate(firstName, link),
        link: link,
    };
};

const declinePostTemplate = (firstName, postId) => {
    return emailTemplate(
        `
                        <h1 class="body-text">Hi ${firstName}</h1>
                        <b class="body-text">We’ve just reviewed your recent post and it was rejected.</b> 
                        <p class="body-text" style="margin-top: 30px">Sorry to say this, but it seems like the content you used in your post isn’t appropriate or inline with our rules. It may not be relevant or perhaps it’s showing explicit imagery or wording.
We make sure all the content is quality checked to improve the experience for our users.</p>
                        <p class="body-text" style="margin-bottom: 30px;">However, don’t fret, we’ve saved your post so you can swap out the imagery or text and re-submit by clicking the button below.</p>
                        <p class="body-text" style="margin-bottom: 30px;">If you think this was a mistake then please email us at <a href="mailto:support@validate.biz">support@validate.biz</a></p>
                        <p class="body-text" style="margin-bottom: 30px;">Thanks for understanding!<a href="mailto:support@validate.biz">support@validate.biz</a></p>
                        <b class="body-text">Validate team</b>
                        `,
        'Go to post',
        `${window.location.origin}/posts/${postId}`,
        {
            headerColor: '#FEE8EF',
            logoColor: '#FA6D8E',
            bodyBg:
                'https://firebasestorage.googleapis.com/v0/b/validate-web-platform.appspot.com/o/static%2Freject_email_bg.png?alt=media&token=3863b6b6-7fb8-49f2-a65a-9b0379947e57',
        },
        IS_SIDEKICK_APP
    );
};

export const getDeclinePostTemplate = (email, firstName, postId) => {
    return {
        subject: `Uh oh there seems to be a problem.`,
        sendTo: [email],
        body: declinePostTemplate(firstName, postId),
        link: 'links',
    };
};

const acceptEmailTemplate = (firstName, postId) => {
    return emailTemplate(
        `
                        <h1 class="body-text">Hi ${firstName}</h1>
                        <b class="body-text">Congratulations! Your post is out in the big wide world. </b> 
                        <p class="body-text" style="margin-top: 30px; margin-bottom: 30px;">We really hope you get the advice that you need. Since we’re a relatively new platform, we’d like to ask kindly for your patience. If you’ve invited the Validate community to answer your question then it might take a little more time for your post to pick up traction. We’re doing our very best to grow the community, so stick with us!</p>
                        <p class="body-text" style="margin-bottom: 30px;">One small step for you. One giant leap for your ideas!</p>
                        <b class="body-text">Validate team</b>
                        `,
        'View post',
        `${window.location.origin}/posts/${postId}`,
        {
            headerColor: '#DDE0E6',
            logoColor: '#1B3256;',
            bodyBg:
                'https://firebasestorage.googleapis.com/v0/b/validate-web-platform.appspot.com/o/static%2Fapprove_email_bg.png?alt=media&token=f9d59883-40a7-421e-9d9a-77419076ccea',
        },
        IS_SIDEKICK_APP
    );
};

export const getAcceptPostTemplate = (email, firstName, postId) => {
    return {
        subject: `Your post is approved!`,
        sendTo: [email],
        body: acceptEmailTemplate(firstName, postId),
        link: 'links',
    };
};

const receiveMoneyEmailTemplate = (firstName, senderFirstName, link) => {
    return emailTemplate(
        `
                        <h1 class="body-text">Hi ${firstName}</h1>
                        <b class="body-text">Celebrations are in order! You’ve only gone and done it… </b> 
                        <p class="body-text" style="margin-top: 30px; margin-bottom: 30px;">Seems like ${senderFirstName} liked your idea enough to pay you. Please click “accept payment” below and you’ll be redirected to the Validate platform.</p>
                        <p class="body-text" style="margin-bottom: 30px;">A special well done from us here at Validate. Thanks to users like you ideas are born and improved every day.</p>
                        <p class="body-text" style="margin-bottom: 30px;">Look after your brain and keep up the great thinking!</p>
                        <b class="body-text">Validate team</b>
                        `,
        'View post',
        link,
        {
            headerColor: '#DDE0E6',
            logoColor: '#1B3256;',
            bodyBg:
                'https://firebasestorage.googleapis.com/v0/b/validate-web-platform.appspot.com/o/static%2Freceive_payment_email_bg.png?alt=media&token=44afc7a7-12b4-42d8-b198-a3bdc8e39616',
        },
        IS_SIDEKICK_APP
    );
};

export const getReceiveMoneyEmailTemplate = (email, firstName, senderFirstName) => {
    return {
        subject: `Someone’s paid you!`,
        sendTo: [email],
        body: receiveMoneyEmailTemplate(firstName, senderFirstName, window.location.origin),
        link: 'links',
    };
};

const receiveMoneyWithoutStripeAccountEmailTemplate = (firstName, senderFirstName, link) => {
    return emailTemplate(
        `
                        <h1 class="body-text">Hi ${firstName}</h1>
                        <b class="body-text">Celebrations are in order! We just need a few more details…  </b> 
                        <p class="body-text" style="margin-top: 30px; margin-bottom: 30px;">Seems like ${senderFirstName} liked your idea enough to pay you. In order to receive the funds you’ll need to setup a Stripe account, but don’t worry this is really easy. Please click “accept payment” below and you’ll be redirected to setup your Stripe account. This will only take a moment!</p>
                        <p class="body-text" style="margin-bottom: 30px;">A special well done from us here at Validate. Thanks to users like you ideas are born and improved every day.</p>
                        <p class="body-text" style="margin-bottom: 30px;">Look after your brain and keep up the great thinking!</p>
                        <b class="body-text">Validate team</b>
                        `,
        'View post',
        link,
        {
            headerColor: '#DDE0E6',
            logoColor: '#1B3256;',
            bodyBg:
                'https://firebasestorage.googleapis.com/v0/b/validate-web-platform.appspot.com/o/static%2Freceive_payment_email_bg.png?alt=media&token=44afc7a7-12b4-42d8-b198-a3bdc8e39616',
        },
        IS_SIDEKICK_APP
    );
};

export const getReceiveMoneyWithoutStripeAccountEmailTemplate = (
    email,
    firstName,
    senderFirstName,
    link = `${window.location.origin}`
) => {
    return {
        subject: `Someone’s paid you!`,
        sendTo: [email],
        body: receiveMoneyWithoutStripeAccountEmailTemplate(firstName, senderFirstName, link),
        link: 'links',
    };
};

const inviteToAnswerTemplate = (link, firstName, userMessage) => {
    return emailTemplate(
        `
                <h1 class="body-text">Hi</h1>
                <b class="body-text">Exciting! Seems like you’ve been invited by ${firstName} to answer a question.</b>
                <p class="body-text" style="margin-top: 30px">${userMessage}</p>
                <p class="body-text" style="margin-bottom: 30px;">Your wisdom is needed! You simply need to click the button below and we’ll direct you to the post. You’ll need to sign-up but this just takes a moment.</p>
                <p class="body-text" style="margin-bottom: 30px;">Alone we can do so little, but together we can do so much!</p>
                <b class="body-text">Validate team</b>
                `,
        'Go to post',
        link,
        {
            headerColor: '#E2F8FB',
            logoColor: '#44D1E3',
            bodyBg:
                'https://firebasestorage.googleapis.com/v0/b/validate-web-platform.appspot.com/o/static%2Finvite_email_bg.png?alt=media&token=bfb440f0-7a18-4502-9875-6c6b5ff4d71f',
        },
        IS_SIDEKICK_APP
    );
};

export const getInviteToAnswerTemplate = (emails, firstName, userMessage, link) => {
    return {
        subject: `Your brain is needed!`,
        sendTo: emails,
        body: inviteToAnswerTemplate(link, firstName, userMessage),
        link: 'links',
    };
};
